import {theme} from "../index";

export const color = (key: string) => theme.palette.customColors[key];
